import { useState } from 'react';

export type BafaReason = { code: string; severity: 'rot' | 'gelb' };

const REASON_LABELS: Record<string, string> = {
  sitz_nicht_de: 'Sitz nicht in Deutschland',
  kein_kmu_mitarbeiter: 'Kein KMU: 250 oder mehr Mitarbeiter',
  kein_kmu_finanzen: 'Kein KMU: Umsatz und Bilanzsumme über den Schwellen',
  oeffentliche_beteiligung: 'Öffentliche Beteiligung über 25 %',
  unternehmen_in_schwierigkeiten: 'Unternehmen in Schwierigkeiten',
  vorfoerderung_ueber_deminimis: 'Vorförderungen über De-minimis-Grenze',
  branche_ausgeschlossen: 'Branche ist von der Förderung ausgeschlossen',
  daten_unvollstaendig: 'Pflichtangaben fehlen noch',
  gruppenwerte_noetig: 'Partner-/verbundenes Unternehmen — Gruppenwerte nötig',
  branche_unbekannt: 'Branche/Beratungsart noch prüfen',
  pruefung_fehlgeschlagen: 'Prüfung fehlgeschlagen — bitte manuell prüfen',
};

const AMPEL_META: Record<string, { dot: string; label: string; text: string }> = {
  gruen: { dot: 'bg-green-500', label: 'Förderfähig', text: 'text-green-700' },
  gelb: { dot: 'bg-amber-500', label: 'Prüfen', text: 'text-amber-700' },
  rot: { dot: 'bg-red-500', label: 'Nicht förderfähig', text: 'text-red-700' },
};

export function reasonLabel(code: string): string {
  return REASON_LABELS[code] ?? code;
}

export function BafaCheckBadge({
  ampel,
  reasons = [],
  compact = false,
}: {
  ampel?: string | null;
  reasons?: BafaReason[];
  compact?: boolean;
}) {
  const [open, setOpen] = useState(false);
  if (!ampel) {
    return <span className="text-xs text-slate-400" title="Noch nicht geprüft">BAFA: –</span>;
  }
  const meta = AMPEL_META[ampel] ?? AMPEL_META.gelb;
  if (compact) {
    return (
      <span className="inline-flex items-center" title={`BAFA-Check: ${meta.label}`}>
        <span className={`w-2.5 h-2.5 rounded-full ${meta.dot}`} />
      </span>
    );
  }
  return (
    <div className="text-sm">
      <button type="button" onClick={() => setOpen(o => !o)} className="inline-flex items-center gap-2">
        <span className={`w-3 h-3 rounded-full ${meta.dot}`} />
        <span className={`font-medium ${meta.text}`}>BAFA-Check: {meta.label}</span>
        {reasons.length > 0 && <span className="text-xs text-slate-400">({reasons.length})</span>}
      </button>
      {open && reasons.length > 0 && (
        <ul className="mt-1 ml-5 list-disc text-xs text-slate-600">
          {reasons.map((r) => (
            <li key={r.code}>{reasonLabel(r.code)}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
